import React, { useState, useEffect } from "react";
import { sendAppierConversion } from "../tracking/appier";
import { trackButtonClick, parseCurrentUriAds } from "../tracking/tracker";

export const Header = (props) => {
  const [links, setLinks] = useState({
    //line: "https://liff.line.me/2006508428-LaMj0Q6M",
    line: "line://app/2007605903-BR0b43NW?_ads=Home_header_line",
    web: "https://play.bwd.tw/?_ads=Home_header_web",
  });

  useEffect(() => {
    const { ads, ref } = parseCurrentUriAds();
    console.log("parseCurrentUriAds:", { ads, ref });

    // 若 ads 或 ref 有其一存在
    if (ads || ref) {
      setLinks((prevLinks) => {
        const updatedLinks = {};

        Object.keys(prevLinks).forEach((key) => {
          try {
            const url = new URL(prevLinks[key]);

            // 用真正的值分別設定 → 不會 double encode
            if (ads) url.searchParams.set("_ads", ads);
            if (ref) url.searchParams.set("ref", ref);

            updatedLinks[key] = url.toString();
          } catch (error) {
            console.error(`Error updating ${key} link:`, error.message);
            updatedLinks[key] = prevLinks[key]; // 保留原始連結
          }
        });

        return updatedLinks;
      });
    }
  }, []); // mount 時跑一次

  return (
    <header id="header">
      <div className="intro">
        <div className="container">
          <div className="row">
            <div className="col-md-12 intro-text">
               <a href={links.web} className="btn btn-intro page-scroll">
                <img src="img/intro-btn-web.png" className=" " alt="" />
              </a>{" "}
              <a href={links.line} className="btn btn-intro page-scroll">
                <img src="img/intro-btn-line.png" className=" " alt="" />
              </a>{" "}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};